import { render, staticRenderFns } from "./TextAnnouncementEditForm.vue?vue&type=template&id=4ff4b8ac&scoped=true"
import script from "./TextAnnouncementEditForm.vue?vue&type=script&lang=js"
export * from "./TextAnnouncementEditForm.vue?vue&type=script&lang=js"
import style0 from "./TextAnnouncementEditForm.vue?vue&type=style&index=0&id=4ff4b8ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff4b8ac",
  null
  
)

export default component.exports